import _ from 'lodash';
import React, {useRef, useState, useEffect, useCallback} from "react";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import canAutoPlay from 'can-autoplay';


export const useVideoJS = (videoJsOptions, classNames = "", playerRef = null) => {
  const videoNode = useRef(null);
  const [ready, setReady] = useState(false);
  const changedKey = JSON.stringify(videoJsOptions);
  const player = playerRef || useRef(null);
  useEffect(() => {
    player.current = videojs(videoNode.current, videoJsOptions);
    player.current.ready(() => {
      setReady(true);
    });

    canAutoPlay.video({inline: true}).then(({result}) => {
      if (result === true) {
        // Can autoplay
        const playButton = player.current.getChild('bigPlayButton');
        if(playButton){
          playButton.hide();
        }
      } else {
        // Can not autoplay
      }
    })

    return () => {
      player.current.dispose();
    };
  }, [changedKey]);

  const Video = useCallback(
    ({children, ...props}) => (
      <div data-vjs-player key={changedKey}>
        <video ref={videoNode} className={`video-js ${classNames}`} {...props}>
          {children}
        </video>
      </div>
    ),
    [changedKey]
  );
  return {Video, ready, player: player.current};
};
